import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    BulbMessage,
    PayoutRules,
    AcceptChanges,
    IUnderstandUnavailable,
    AcceptOfferBtn,
    PlaceButtons,
    LogInToPlaceBet,
} from './BetslipButtonsElements';
import { BetButtonsWrapper } from './BetSlipButtons.style';
import { BetslipFooter } from 'src/domains/sportsbook/betting/ui/betSlip/betslipFooter/BetslipFooter';
import { useCommon } from 'src/domains/common/Common';
import { AlertBannerInline } from 'src/domains/layouts/webview/components/alertBanner/Inline';

const BetSlipButtonsInner = observer('BetSlipButtonsInner', () => {
    const common = useCommon();
    const appSportsBookState = AppSportsBookState.get(common);
    const { betSlipState } = appSportsBookState;
    const { session } = common;

    if (session.isAuthorized) {
        if (betSlipState.betSlipSummaryState.isUnavailableSelectionsWarning) {
            return <IUnderstandUnavailable />;
        } else if (betSlipState.betSlipSummaryState.isLegsChangedWarning) {
            return <AcceptChanges />;
        } else if (betSlipState.referralState.isBetSlipOffer) {
            return <AcceptOfferBtn />;
        } else {
            return <PlaceButtons />;
        }
    } else {
        return <LogInToPlaceBet />;
    }
});

export const BetSlipButtons = observer('BetSlipButtons', () => {
    const common = useCommon();
    const appSportsBookState = AppSportsBookState.get(common);
    const { betSlipState } = appSportsBookState;

    const { isRejectedBet } = betSlipState.referralState;
    const { isShowQuickBet } = betSlipState.basicBetSlipState;
    const { isVisibleKeyBoard, focusedSelectionId } = betSlipState.basicBetSlipState;
    const showFreeBetButton =
        !common.features.bonusEngine &&
        betSlipState.freeBetsAmount !== null &&
        betSlipState.freeBetsAmount.isGreaterThanZero();

    if (isRejectedBet) {
        return null;
    }

    if (isShowQuickBet) {
        return (
            <>
                <BetButtonsWrapper visibleKeyboard={isVisibleKeyBoard && focusedSelectionId !== null}>
                    <BetSlipButtonsInner />
                    <AlertBannerInline
                        marginTop='8px'
                        marginBottom='8px'
                        message={<PayoutRules />}
                        size='small'
                    />
                </BetButtonsWrapper>
                {showFreeBetButton ? <BulbMessage /> : null}
            </>
        );
    }

    return (
        <BetButtonsWrapper visibleKeyboard={isVisibleKeyBoard && focusedSelectionId !== null}>
            <BetSlipButtonsInner />
            <AlertBannerInline
                marginBottom='8px'
                message={<PayoutRules />}
                size='small'
            />
            <BetslipFooter />
            {showFreeBetButton ? <BulbMessage /> : null}
        </BetButtonsWrapper>
    );
});
